import React, { useState, useEffect } from 'react';
import { TextField } from '@mui/material';
import { updatedCarrinhoQuantidade } from '../../../services/dexie/stores';

export function QuantidadeField({ item, setData }) {
  const [localQuantidade, setLocalQuantidade] = useState(item.quantidade);

  // Sincroniza o estado local quando item.quantidade mudar de fora
  useEffect(() => {
    setLocalQuantidade(item.quantidade);
  }, [item.quantidade]);

  // Atualiza banco e estado global com debounce de 500ms após última digitação
  useEffect(() => {
    const handler = setTimeout(() => {
      if (localQuantidade !== item.quantidade) {
        updatedCarrinhoQuantidade(item.id, localQuantidade);

        setData((prevData) =>
          prevData.map((d) =>
            d.id === item.id ? { ...d, quantidade: localQuantidade } : d
          )
        );
      }
    }, 500);

    return () => clearTimeout(handler); // limpa timeout se digitar antes de 500ms
  }, [localQuantidade, item, setData]);

  return (
    <TextField
      id="standard-basic"
      variant="standard"
      type="number"
      value={localQuantidade}
      inputProps={{ min: 1, style: { textAlign: 'center' } }}
      onChange={(e) => {
        setLocalQuantidade(e.target.value);
      }}
    />
  );
}
